import { z } from 'zod';
import { requiredClientGeneratedUuidString, requiredUuidString } from '../zod-helpers/index.js';
import { rmaReturnQtySchema } from './rma-return-qty.js';
import { rmaReturnReasonSchema } from './rma-return-reason.js';
import { uniqueLineList } from './unique-line-list.js';
const rmaPreviewLineInputSchema = z.object({
    salesOrderItemId: requiredUuidString('Sales order line is required.', 'Invalid sales order line selection.'),
    qty: rmaReturnQtySchema,
});
const rmaLineInputSchema = rmaPreviewLineInputSchema.extend({ reason: rmaReturnReasonSchema });
const salesOrderId = requiredUuidString('Sales order is required.', 'Invalid sales order selection.');
/** What the Create RMA dialog shows before Create (N19); lines may be empty while nothing is chosen. */
export const salesOrderRmaPreviewInputSchema = z.object({
    salesOrderId,
    lines: uniqueLineList(rmaPreviewLineInputSchema),
});
// Each returned line carries its own required reason (N19, OTC-45); one key per dialog open creates one RMA.
export const createSalesOrderRmaInputSchema = z.object({
    salesOrderId,
    lines: uniqueLineList(rmaLineInputSchema).refine((rows) => rows.length > 0, 'Choose at least one line to return.'),
    idempotencyKey: requiredClientGeneratedUuidString('Return confirmation key is required.', 'Invalid return confirmation key.'),
});
//# sourceMappingURL=rma-input.js.map